import type { SVGProps } from 'react'

interface CircleSlashIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}

/**
 * Circle with diagonal slash icon - commonly used for unavailable/blocked states
 */
export const CircleSlashIcon = ({
  size = 20,
  className = 'size-5 text-danger-text',
  ...props
}: CircleSlashIconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <circle cx='10' cy='10' r='9' stroke='currentColor' strokeWidth='2' />
      <line
        x1='5.5'
        y1='5.5'
        x2='14.5'
        y2='14.5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  )
}
